export const stickyNavigator = function (opts) {
  const self = document.querySelector(opts.stickyId);
  const targets = document.querySelectorAll(`${opts.wrapselector} ${opts.targetselector}`);
  let navigationMenu = '';

  targets?.forEach(function (target: any) {
    const text = target.textContent;
    if (text.trim() !== '') {
      const num = Math.floor(Math.random() * 99999999);
      const href = 'js-nav-' + num;

      target.classList.add("js-nav");
      target.classList.add(href);
      target.num = num;

      let clazz = 'nav-' + target.tagName.toLowerCase();
      clazz = clazz + ' nav-' + num;
      navigationMenu += '<li class="' + clazz + '"><a href=".' + href + '">' + text + '</li>';
    }
  });

  self.innerHTML = `<ul>${navigationMenu}</ul>`;

  document.querySelectorAll(`${opts.stickyId} li a`).forEach(function (link) {
    link.addEventListener('click', function (event) {
      event.preventDefault();
      const to: any = document.querySelector(link.getAttribute('href')!);
      if (to.offsetTop) {
        window.scrollTo({ top: to.offsetTop - 70, behavior: 'smooth' });
      }
    });
  });
}
